import { useState, useEffect } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Story from "./components/Story";
import Tokenomics from "./components/Tokenomics";
import Roadmap from "./components/Roadmap";
import Footer from "./components/Footer";
import FAQ from "./components/Faq";
import Donation from "./components/Donation";
import Banner from "./components/Banner";
import Leaderboard from "./components/Leaderboard";
import DonationBic from "./components/DonationBic";

function App() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative">
      <Navbar />
      <Banner />
      <Hero />
      <Story />
      <Tokenomics />
      <Roadmap />
      <Donation />
      <FAQ />
      <Footer />

      {showButton && (
        <div
          onClick={scrollToTop}
          className="back-to-top"
          aria-label="Back to top"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && scrollToTop()}
        >
          <svg
            data-name="1-Arrow Up"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="back-to-top-icon"
          >
            <path d="M26.71 10.29l-10-10a1 1 0 0 0-1.41 0l-10 10 1.41 1.41L15 3.41V32h2V3.41l8.29 8.29z" />
          </svg>
        </div>
      )}
    </div>
  );
}

export default App;
